import { mapActions } from 'vuex'
import modulos from '@/mixins/modulos'
const grisFondo = 'grey lighten-4'
const grisTexto = 'grey--text text--darken-1'
const amarilloFondo = 'yellow lighten-4'
const amarilloTexto = 'yellow--text text--darken-2'
const rojoFondo = 'red lighten-4'
const rojoTexto = 'red--text text--darken-2'

const validando = {
  id: 'validando',
  claseTexto: amarilloTexto,
  claseTextoPequeno: amarilloTexto,
  claseFondo: amarilloFondo
}
const esperando = {
  id: 'esperando',
  claseTexto: amarilloTexto,
  claseTextoPequeno: amarilloTexto,
  claseFondo: amarilloFondo
}
const pendienteFirmar = {
  id: 'pendienteFirmar',
  claseTexto: 'titleColor--text',
  claseTextoPequeno: grisTexto,
  claseFondo: grisFondo
}
const completado = {
  id: 'completado',
  claseTexto: 'success--text',
  claseTextoPequeno: 'success--text',
  claseFondo: 'green lighten-4'
}
const proceso = {
  id: 'proceso',
  claseTexto: 'titleColor--text',
  claseTextoPequeno: grisTexto,
  claseFondo: grisFondo
}

const continuable = {
  id: 'continuable',
  claseTexto: 'titleColor--text',
  claseTextoPequeno: grisTexto,
  claseFondo: grisFondo
}
const pendiente = {
  id: 'pendiente',
  claseTexto: grisTexto,
  claseTextoPequeno: grisTexto,
  claseFondo: grisFondo
}
const rechazado = {
  id: 'rechazo',
  claseTexto: rojoTexto,
  claseTextoPequeno: rojoTexto,
  claseFondo: rojoFondo
}

export default {
  mixins: [
    modulos
  ],
  computed: {
    estado () {
      switch (this.id) {
        case 'condiciones':
          return completado
        case 'pago':
          switch (this.codigoEstadoActual) {
            case 1:
              return this.comprobarEstadoAnterior(this.id, this.reserva) ? proceso : pendiente
            case 2:
              return proceso
            case 5:
              return validando
            case 10:
            case 20:
              return completado
            case 91:
              return rechazado
          }
          break
        case 'contrato':
          switch (this.codigoEstadoActual) {
            case 1:
              return this.comprobarEstadoAnterior(this.id, this.reserva) ? proceso : pendiente
            case 2:
              return continuable
            case 3:
              return pendienteFirmar
            case 10:
              return completado
          }
          break
        case 'kyc':
          switch (this.codigoEstadoActual) {
            case 1:
              return this.comprobarEstadoAnterior(this.id, this.reserva) ? proceso : pendiente
            case 2:
              return continuable
            case 3:
              return esperando
            case 5:
              return validando
            case 10:
              return completado
            case 91:
              return rechazado
          }
          break
        case 'documentacion':
          switch (this.codigoEstadoActual) {
            case 1:
              return this.comprobarEstadoAnterior(this.id, this.reserva) ? proceso : pendiente
            case 2:
              return continuable
            case 3:
              return pendienteFirmar
            case 5:
              return validando
            case 10:
              return completado
            case 91:
              return rechazado
          }
          break
        case 'validacionDocumentacion':
          switch (this.codigoEstadoActual) {
            case 1:
              return this.comprobarEstadoAnterior(this.id, this.reserva) ? proceso : pendiente
            case 5:
              return validando
            case 10:
              return completado
          }
          break
        case 'pbc':
          switch (this.codigoEstadoActual) {
            case 1:
              return this.comprobarEstadoAnterior(this.id, this.reserva) ? proceso : pendiente
            case 2:
              return proceso
            case 5:
            case 6:
              return validando
            case 10:
            case 11:
              return completado
            case 91:
            case 92:
              return rechazado
          }
          break
      }
    },
    codigoEstadoActual () {
      switch (this.id) {
        case 'condiciones':
          return 1
        case 'pago':
          return this.reserva.estadoPago.codigoEstadoPago
        case 'contrato':
          return this.reserva.estadoContrato.codigoEstadoContrato
        case 'kyc':
          return this.reserva.estadoKyc.codigoEstadoKyc
        case 'documentacion':
          return this.reserva.estadoDocumentacion.codigoEstadoDocumentacion
        case 'validacionDocumentacion':
          return this.reserva.estadoValidacionDocumentacion.codigoEstadoValidacionDocumentacion
        case 'pbc':
          return this.reserva.estadoPbc.codigoEstadoPbc
      }
    },
    mostrarBotonTextoValidacionPbc () {
      return this.id === 'pbc' &&
        (this.codigoEstadoActual == 91 || this.codigoEstadoActual == 92) &&
        (this.esAdministrador || this.esPbc || this.esComercial) &&
        this.reserva.validacionPbc.textoValidacion != null &&
        this.reserva.validacionPbc.textoValidacion.length > 100
    },
    textoAccion () {
      if (this.estado === completado) {
        return this.$t('mixins.tarjetasReserva.completado')
      } else if (this.estado === pendiente) {
        return this.$t('mixins.tarjetasReserva.pendiente')
      } else if (this.estado === continuable) {
        return this.$t('mixins.tarjetasReserva.acceder')
      } else if (this.estado === validando) {
        if (this.id === 'pbc') {
          if (this.esAdministrador || this.esPbc) {
            return this.reserva.estadoPbc.codigoEstadoPbc === 5 ? this.$t('mixins.tarjetasReserva.revisar') : this.$t('mixins.tarjetasReserva.enRevision')
          }
          return this.$t('mixins.tarjetasReserva.enRevision')
        }
        return this.esAdministrador || this.esPbc || this.esComercial ? this.$t('mixins.tarjetasReserva.revisar') : this.$t('mixins.tarjetasReserva.enRevision')
      } else if (this.estado === esperando) {
        return this.$t('mixins.tarjetasReserva.rellenado')
      } else if (this.estado === rechazado) {
        return this.$t('mixins.tarjetasReserva.rechazado')
      } else if (this.estado === pendienteFirmar) {
        return this.$t('mixins.tarjetasReserva.firmar')
      } else if (this.estado === proceso) {
        return this.$t('mixins.tarjetasReserva.acceder')
      } else {
        return ''
      }
    },
    texto () {
      if (this.estado === pendiente) {
        return this.$t('mixins.tarjetasReserva.pasoAnterior')
      } else if (this.estado === continuable) {
        return this.$t('mixins.tarjetasReserva.borrador')
      } else if (this.estado === validando) {
        if (this.esCliente) {
          return this.$t('mixins.tarjetasReserva.checkEmail')
        }
        if (this.id === 'documentacion' && this.reserva.estadoKyc.codigoEstadoKyc !== 10) {
          return this.$t('mixins.tarjetasReserva.validarKyc')
        }
        if (this.id === 'pbc') {
          if ((!this.esPbc && !this.esAdministrador) || (this.reserva.estadoPbc.codigoEstadoPbc === 5)) {
            return this.$t('mixins.tarjetasReserva.enValidacion')
          } else {
            return this.$t('mixins.tarjetasReserva.enValidacionBO')
          }
        }
      } else if (this.estado === esperando) {
        return this.$t('mixins.tarjetasReserva.subaDocumentacion')
      } else if (this.estado === rechazado) {
        if (this.id === 'pbc') {
          if (this.codigoEstadoActual == 92) {
            if ((this.esAdministrador || this.esPbc || this.esComercial) && this.reserva.validacionPbc.textoValidacion != null) {
              let motivo = this.reserva.validacionPbc.textoValidacion
              if (motivo.length > 100)
              {
                motivo = motivo.substring(0, 100)
              }
              return this.$t('mixins.tarjetasReserva.pbcRechazadoBOMotivo', {motivo: motivo})
            } else {
              return this.$t('mixins.tarjetasReserva.pbcRechazadoBO')
            }
          } else {
            if ((this.esAdministrador || this.esPbc || this.esComercial) && this.reserva.validacionPbc.textoValidacion != null) {
              let motivo = this.reserva.validacionPbc.textoValidacion
              if (motivo.length > 100)
              {
                motivo = motivo.substring(0, 100)
              }
              return this.$t('mixins.tarjetasReserva.pbcRechazadoMotivo', {motivo: motivo})
            } else {
              return this.$t('mixins.tarjetasReserva.pbcRechazado')
            }
          }
        } else {
          return this.$t('mixins.tarjetasReserva.pasoRechazado')
        }
      } else if (this.estado === pendienteFirmar) {
        return this.$t('mixins.tarjetasReserva.completaFirma')
      } else {
        return ''
      }
    },
    textoPopUpAlerta () {
      if (this.estado === pendiente) {
        return this.$t('mixins.tarjetasReserva.pasoAnterior')
      } else if (this.estado === continuable) {
        return this.$t('mixins.tarjetasReserva.borrador')
      } else if (this.estado === validando) {
        if (this.esCliente) {
          return this.$t('mixins.tarjetasReserva.checkEmail')
        }
        if (this.id === 'documentacion' && this.reserva.estadoKyc.codigoEstadoKyc !== 10) {
          return this.$t('mixins.tarjetasReserva.validarKyc')
        }
        if (this.id === 'pbc') {
          if ((!this.esPbc && !this.esAdministrador) || (this.reserva.estadoPbc.codigoEstadoPbc === 5)) {
            return this.$t('mixins.tarjetasReserva.enValidacion')
          } else {
            return this.$t('mixins.tarjetasReserva.enValidacionBO')
          }
        }
      } else if (this.estado === esperando) {
        return this.$t('mixins.tarjetasReserva.subaDocumentacion')
      } else if (this.estado === rechazado) {
        if (this.id === 'pbc') {
          return this.$t('mixins.tarjetasReserva.pbcRechazadoAlert')
        } else {
          return this.$t('mixins.tarjetasReserva.pasoRechazado')
        }
      } else if (this.estado === pendienteFirmar) {
        return this.$t('mixins.tarjetasReserva.completaFirma')
      } else if (this.estado === completado) {
        return this.$t('mixins.tarjetasReserva.yaCompletado')
      } else {
        return ''
      }
    },
    textoValidacionPbc () {
      return this.reserva.validacionPbc.textoValidacion == null ? '' : this.reserva.validacionPbc.textoValidacion
    },
    editable () {
      if (this.waitingForLoad) {
        return false
      }
      switch (this.id) {
        case 'condiciones':
          return false
        case 'pago':
          if (this.codigoEstadoActual === 5) {
            return !this.esCliente
          }
          return (this.codigoEstadoActual === 1 ||
            this.codigoEstadoActual === 2 ||
            this.codigoEstadoActual === 91) &&
            this.comprobarEstadoAnterior(this.id, this.reserva)
        case 'contrato':
          return (this.codigoEstadoActual === 1 ||
            this.codigoEstadoActual === 2 ||
            this.codigoEstadoActual === 3) &&
            this.comprobarEstadoAnterior(this.id, this.reserva)
        case 'kyc':
          if (this.codigoEstadoActual === 5) {
            return !this.esCliente
          }
          return (this.codigoEstadoActual === 1 ||
            this.codigoEstadoActual === 2 ||
            this.codigoEstadoActual === 3 ||
            this.codigoEstadoActual === 91) &&
            this.comprobarEstadoAnterior(this.id, this.reserva)
        case 'documentacion':
          if (this.codigoEstadoActual === 5) {
            return !this.esCliente && this.reserva.estadoKyc.codigoEstadoKyc === 10
          }
          return (this.codigoEstadoActual === 1 ||
            this.codigoEstadoActual === 2 ||
            this.codigoEstadoActual === 3 ||
            this.codigoEstadoActual === 91) &&
            this.comprobarEstadoAnterior(this.id, this.reserva)
        case 'validacionDocumentacion':
          return !this.esPbc && !this.esCliente && (this.codigoEstadoActual === 5) &&
            this.comprobarEstadoAnterior(this.id, this.reserva)
        case 'pbc':
          // return false
          if (this.codigoEstadoActual === 5) {
            return this.esPbc || this.esAdministrador
          } else {
            return false
          }
      }
    },
    visible () {
      if (this.waitingForLoad) {
        return false
      }
      switch (this.id) {
        case 'condiciones':
          return true
        case 'pbc':
          if (this.codigoEstadoActual === 6) {
            return this.esPbc || this.esAdministrador
          } else {
            return false
          }
        case 'validacionDocumentacion':
          return false
        default:
          return this.codigoEstadoActual === 10 || this.codigoEstadoActual === 20
      }
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      enviarCorreoTerminado: 'reservas/enviarCorreoTerminado',
      loadReserva: 'reservas/_id/load'
    }),
    ver () {
      this.$router.push({name: 'reservas.id.' + this.id, params: {id: this.reserva.id}})
    },
    editar () {
      this.$router.push({name: 'reservas.id.' + this.id, params: {id: this.reserva.id}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/tarjetasReserva.js